/**
 * Заголовок и «назад» на форме оплаты (VintedStripe2): для шаблонов Vinted — t.back / t.withdrawTitle
 * как в переводе; для остальных сервисов та же локализованная фраза, но вместо VINTED.XX подставляется бренд.
 */
const VINTED_STYLE_TEMPLATES = new Set([
  'vinted2',
  'vinted_stripe',
  'fi_vinted',
  'lt_vinted',
  'se_vinted',
  'be_vinted',
  'nl_vinted',
  'de_vinted',
  'fr_vinted',
  'es_vinted',
  'pt_vinted',
  'pt_vnited',
  'it_vinted',
  'cz_vinted',
  'bg_vinted',
  'at_vinted',
  'ie_anpost',
  'ro_fancourier',
]);

const VINTED_DOMAIN_IN_LABEL = /\bVINTED\.[A-Z]{2}\b/i;

const BRAND_BY_TEMPLATE = {
  stripe: 'Stripe',
  be_dhl: 'DHL',
  de_dhl: 'DHL',
  de_kleinanzeigen: 'Kleinanzeigen',
  de_quoka: 'Quoka.de',
  de_pet_taxi: 'Zoo Taxi',
  pl_pet_taxi: 'Zoo Taxi',
  ro_pet_taxi: 'Zoo Taxi',
  pt_pet_taxi: 'Zoo Taxi',
  fi_pet_taxi: 'Zoo Taxi',
  ch_pet_taxi: 'Zoo Taxi',
  gb_pet_taxi: 'Zoo Taxi',
  de_booking: 'Booking.com',
  pl_booking: 'Booking.com',
  ro_booking: 'Booking.com',
  pt_booking: 'Booking.com',
  fi_booking: 'Booking.com',
  ch_booking: 'Booking.com',
  gb_booking: 'Booking.com',
  de_dpd: 'DPD',
  be_2dehands: '2dehands',
  ee_dpd: 'DPD',
  lv_dpd: 'DPD',
  lt_dpd: 'DPD',
  lt_skelbiu_siuntos: 'Skelbiu siuntos',
  bg_econt: 'Econt',
  ba_euroexpress: 'EuroExpress',
  ba_bhposta: 'BH Pošta',
  ba_brzaposta: 'Brza pošta',
  ba_xexpress: 'X Express',
  fi_posti: 'Posti',
  fi_tori: 'Tori',
  ch_tutti: 'tutti.ch',
  ch_ricardo: 'Ricardo',
  ch_swisspost: 'Die Post',
  ch_clozen: 'Clozen',
  cz_ppl: 'PPL',
  cz_gls: 'GLS',
  cz_dpd: 'DPD',
  cz_aukro: 'Aukro',
  dk_gls: 'GLS',
  dk_dba: 'DBA',
  dk_dao: 'dao',
  dk_guloggratis: 'GulogGratis',
  es_wallapop: 'Wallapop',
  it_wallapop: 'Wallapop',
  it_bakeca: 'Bakeca.it',
  it_subito: 'Subito',
  it_spedire: 'Spedire.com',
  is_bland: 'Bland.is',
  ie_anpost: 'An Post',
  ro_fancourier: 'FAN Courier',
  ro_olx: 'OLX',
  pt_olx: 'OLX',
  pt_custojusto: 'CustoJusto',
  pt_ctt: 'CTT',
  pt_vnited: 'Vinted',
  pl_sprzedajemy: 'Sprzedajemy.pl',
  pl_poczta: 'Poczta Polska',
  pl_dpd: 'DPD',
  no_posten: 'Posten',
  nl_postnl: 'PostNL',
  nl_marktplaats: 'Marktplaats',
  nl_dpd: 'DPD',
  nl_dhl: 'DHL',
  sk_packeta: 'Packeta',
  sk_eposta: 'ePošta',
  sk_posta: 'Posta.sk',
  sk_dpd: 'DPD',
  sk_bazos: 'Bazoš',
  se_tradera: 'Tradera',
  se_instabox: 'Instabox',
  se_dhl: 'DHL',
  se_dbschenker: 'DB SCHENKER',
  se_blocket: 'Blocket',
  es_milanuncios: 'Milanuncios',
  es_correos: 'Correos',
  hu_gls: 'GLS',
  hu_jofogas: 'Jófogás',
  my_carousell: 'Carousell',
  hr_posta: 'Hrvatska pošta',
  fr_leboncoin: 'leboncoin',
  fr_ungrandmarche: 'Un Grand Marché',
  fr_tracevelo: 'tracevélo',
  fr_vinted: 'Vinted',
  md_novaposhta: 'Nova Poshta',
  olx: 'OLX',
  inpost: 'InPost',
  at_paylivery: 'PayLivery',
  at_willhaben: 'willhaben',
  at_landleanzeigen: 'Kleinanzeigen',
  at_shpock: 'Shpock',
};

function headerStringsForServiceBrand(t, brand) {
  const back = (t.back || '').trim();
  const title = (t.withdrawTitle || '').trim();
  return {
    backText: VINTED_DOMAIN_IN_LABEL.test(back) ? back.replace(VINTED_DOMAIN_IN_LABEL, brand) : `← ${brand}`,
    headline: VINTED_DOMAIN_IN_LABEL.test(title) ? title.replace(VINTED_DOMAIN_IN_LABEL, brand) : title || brand,
  };
}

export function getPaymentFormHeaderLabels(template, t) {
  const tpl = template || 'vinted2';
  if (VINTED_STYLE_TEMPLATES.has(tpl)) {
    return {
      backText: t.back,
      headline: t.withdrawTitle,
    };
  }
  let brand = BRAND_BY_TEMPLATE[tpl];
  if (!brand && typeof tpl === 'string') {
    if (tpl.endsWith('_pet_taxi')) brand = 'Zoo Taxi';
    else if (tpl.endsWith('_booking')) brand = 'Booking.com';
    else brand = tpl.replace(/_/g, ' ');
  }
  brand = brand || tpl.replace(/_/g, ' ');
  return headerStringsForServiceBrand(t, brand);
}
